import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconChevronRight = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-chevron-right" data-icon="icon-chevron-right" aria-hidden="true" {...props} ref={ref}><polyline points="9 18 15 12 9 6"/></svg>);
});

IconChevronRight.displayName = 'IconChevronRight';
